// STICKY ITEMS
tetloose.sticky = function () {
    var $rail = $('[rel=js-sticky]');
    if ($rail.length) {
        var $item = $('[rel=js-sticky__item]'),
            $fixedTopPosition = $mastHead.outerHeight(),
            $padding = $item.outerHeight(),
            $offsetFromTop = $rail.offset().top - ( $window.scrollTop() + $fixedTopPosition );

        if ($item.is(':hidden')) {
            $rail.css('padding-top', '');
        } else {
            $rail.css('padding-top', $padding);
        }
        if ($offsetFromTop <= 0) {
            $item.addClass('is-fixed');
            $item.css('top', $fixedTopPosition);
        } else {
            $item.removeClass('is-fixed');
            $item.css('top', '');
        }
    }
}
